import { render, staticRenderFns } from "./CompactList.vue?vue&type=template&id=9ba4652e&scoped=true"
import script from "./CompactList.vue?vue&type=script&lang=js"
export * from "./CompactList.vue?vue&type=script&lang=js"
import style0 from "./CompactList.vue?vue&type=style&index=0&id=9ba4652e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba4652e",
  null
  
)

export default component.exports